import { Component, OnInit } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CalculationService, HelperService } from 'app/services';

interface IDiscount {
    name: string;
    amount: number;
    isTaxable: boolean;
    associatedWith: any;
}

@Component({
    selector: 'app-add-item-discount-dialog',
    templateUrl: './add-item-discount-dialog.component.html',
    styleUrls: ['./add-item-discount-dialog.component.scss'],
})
export class AddItemDiscountDialogComponent implements OnInit {

    discount: IDiscount = {
        name: '',
        amount: null,
        isTaxable: false,
        associatedWith: {}
    };
    taxableOptions: any[] = [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
    ];
    associateWithOptions: any[] = [];
    error: any = {};
    focus: any = {};
    usd: string = currency.USD;
    totalsSummary: any = {
        subTotal: 0,
        discount: 0
    };

    constructor(
        private dynamicDialogRef: DynamicDialogRef,
        private dynamicDialogConfig: DynamicDialogConfig,
        private helperService: HelperService,
        private calculationService: CalculationService
    ) {

    }
    ngOnInit(): void {
        const { associatedWithOptions = [], totalsSummary } = this.dynamicDialogConfig.data;
        if(associatedWithOptions?.length) {
            this.associateWithOptions = this.helperService.deepCopy(associatedWithOptions);
        }
        this.totalsSummary = this.helperService.deepCopy(totalsSummary);
    }

    handleChange(key: string, value: any) {
        this.discount[key] = value;
        if(key === 'associatedWith') {
            this.error[key] = false;
        }
        
    }

    handleBlur(key: string) {
        this.focus[key] = false;
    }

    handleFocus(key: string) {
        this.focus[key] = true;
        this.error[key] = false;
        if(key === 'amount') {
            this.error.amountError = '';
        }
    }

    handleClose(isSuccess: boolean = false) {
        if(isSuccess) {
            const amt = this.calculationService.roundOff(this.discount.amount);
            const id = Date.now();
            const obj = {
                type: 'discount',
                title: this.discount.name,
                amount: amt,
                isTaxable: this.discount.isTaxable,
                cost: amt,
                actualCost: amt,
                count: 1,
                associatedWith: this.discount.associatedWith,
                itemInternalReference: id,
                itemId: id,
                price: amt,
                associatedItemsInternalReferences: [],
                orderItemId: id,
            };
            this.dynamicDialogRef.close({ isSuccess, discountObj: obj });
        } else {
            this.dynamicDialogRef.close({ isSuccess });
        }
        
    }

    isValidData() {
        let isValid: boolean = true;
        if(!this.discount.name) {
            this.error.name = true;
            isValid = false;
        }

        if(!this.discount.amount) {
            this.error.amount = true;
            isValid = false;
        }

        if(Number(this.discount.amount) > this.totalsSummary?.subTotal) {
            this.error.amountError = 'Discount cannot be greater than total amount';
            this.error.amount = true;
            isValid = false;
        }

        if(this.totalsSummary?.discount > 0 && (Number(this.discount.amount) + this.totalsSummary?.discount) > this.totalsSummary?.subTotal) {
            this.error.amountError = 'Total discount cannot be more than total amount';
            this.error.amount = true;
            isValid = false;
        }

        if(!this.discount.associatedWith?._id) {
            this.error.associatedWith = true;
            isValid = false;
        }

        return isValid;
    }
    
    handleSubmit() {
        if(this.isValidData()) {
            this.handleClose(true);
        }
    }

}